import React from 'react';

import MetricBox from './MetricBox';

interface FlightTimeToHomeProps {
  seconds: number;
}

const format = (seconds: number): string => {
  const m = Math.floor(seconds / 60)
    .toString()
    .padStart(2, '0');
  const s = Math.floor(seconds % 60)
    .toString()
    .padStart(2, '0');
  return `${m}:${s}`;
};

const FlightTimeToHome: React.FC<FlightTimeToHomeProps> = ({ seconds }) => (
  <MetricBox label='Flight Time to Home' value={format(seconds)} />
);

export default FlightTimeToHome;
